<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="!item.children || item.hiddenChild">
      <el-menu-item :index="resolvePath(item.path)">
        <router-link  :to="resolvePath(item.path)">{{ item.meta.title }}</router-link>
      </el-menu-item>
    </template>

    <el-submenu v-else  class="errr" popper-class='submenu'  :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <span>{{ item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
// import Item from './Item'
// import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  // components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    resolvePath (routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        // return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
<style lang='scss' scoped>
.itemTitle{
  font-size:16px;
}
.nest-menu:hover{
  color: #105fa8;
  border-bottom:6px solid #105fa8;
}
</style>
